import { render, staticRenderFns } from "./AccountRetention.vue?vue&type=template&id=38aa7c58&"
import script from "./AccountRetention.vue?vue&type=script&lang=js&"
export * from "./AccountRetention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports